export default {
    orderItemIsValid (orderItem) {
        if (orderItem.quantity === null || orderItem.quantity === '') {
            return false
        }

        return true
    }
}
